var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPropertiesActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.705 10.2409L7.23499 5.08984",
    stroke: "#4B74BE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.94 16.793V8.8523C19.9398 8.50431 19.8528 8.16249 19.6878 7.86113C19.5228 7.55977 19.2856 7.30945 19 7.13527L12.411 3.16437C12.1249 2.99015 11.8004 2.89844 11.47 2.89844C11.1396 2.89844 10.8151 2.99015 10.529 3.16437L3.941 7.13527C3.65517 7.30931 3.41777 7.55958 3.2526 7.86095C3.08744 8.16232 3.00033 8.5042 3 8.8523V16.793C3.00103 17.1404 3.08847 17.4814 3.2536 17.782C3.41873 18.0826 3.65576 18.3322 3.941 18.5059L10.529 22.4768C10.8151 22.651 11.1396 22.7427 11.47 22.7427C11.8004 22.7427 12.1249 22.651 12.411 22.4768L19 18.5059C19.2851 18.332 19.5219 18.0824 19.6868 17.7818C19.8518 17.4813 19.9391 17.1403 19.94 16.793Z",
    stroke: "#4B74BE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25403 7.81934L11.47 12.8323L19.684 7.81934",
    stroke: "#4B74BE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.47 22.8281V12.8223",
    stroke: "#4B74BE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertiesActive);
export default __webpack_public_path__ + "static/media/PropertiesActive.478e1a1bf44c7c040d6945b582506dba.svg";
export { ForwardRef as ReactComponent };